// Ported from native/src/editor/activity/plugins/challenge/MoonwalkMachineFlow.js:215-223.
// Phase-machine activity: success = terminal state in runTrace OR phaseFlags.completed.

'use strict';

const {reachedTerminalState, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const phaseFlags = (simState && simState.phaseFlags) || {};
    return {
        success: reachedTerminalState(simState),
        usedBlocks: totalBlockCount(simState),
        storyPhase: phaseFlags.storyPhase || null,
        flagTapCount: phaseFlags.flagTapCount || 0,
        maxLoopDepth: phaseFlags.maxLoopDepth || 0
    };
}

module.exports = evaluate;
